const USER = 'User';

const ITEM_TIMES = 'itemTimes';

const CHAT_RESPONSE = 'chatResponse';

const APP = 'appEvents';

export { USER, ITEM_TIMES, CHAT_RESPONSE, APP };
